import { Button, Stack } from "@mui/material"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"

import ControlledDropDown from "../controlledInputs/ControlledDropDown"
import useUpdateAdvertisementSlots from "@/hooks/api/advertisements/useUpdateAdvertisementSlots"
import { useSnackbar } from "@/contexts/SnackbarContext"

const slotFormSchema = z.object({
  left_large: z.string().optional(),
  right_large: z.string().optional(),
  left_small: z.string().optional(),
  right_small: z.string().optional(),
  mobile_1: z.string().optional(),
  // mobile_2: z.string().optional(),
  // mobile_3: z.string().optional(),
  // mobile_4: z.string().optional(),
})
export type SlotFormFormDataType = z.infer<typeof slotFormSchema>

type Option = {
  label: string
  value: string
}

interface SlotFormProps {
  advertisementSlots: {
    advertisement_id: number
    mapping_id: number
    priority: number
    slot_id: number
    slot_name: string
  }[]
  largeImages: Option[]
  smallImages: Option[]
  mobileImages: Option[]
}

export default function SlotForm({
  advertisementSlots,
  largeImages,
  smallImages,
  mobileImages,
}: SlotFormProps) {
  const { showSnackbar } = useSnackbar()
  const { mutateAsync: updateSlots } = useUpdateAdvertisementSlots()

  const defaultValues: SlotFormFormDataType = {
    left_large:
      String(
        advertisementSlots.find(
          (advertisement) => advertisement.slot_name === "left_large"
        )?.advertisement_id
      ) || "",
    right_large:
      String(
        advertisementSlots.find(
          (advertisement) => advertisement.slot_name === "right_large"
        )?.advertisement_id
      ) || "",
    left_small:
      String(
        advertisementSlots.find(
          (advertisement) => advertisement.slot_name === "left_small"
        )?.advertisement_id
      ) || "",
    right_small:
      String(
        advertisementSlots.find(
          (advertisement) => advertisement.slot_name === "right_small"
        )?.advertisement_id
      ) || "",
    mobile_1:
      String(
        advertisementSlots.find(
          (advertisement) => advertisement.slot_name === "mobile_1"
        )?.advertisement_id
      ) || "",
    // mobile_2:
    //   String(
    //     advertisementSlots.find(
    //       (advertisement) => advertisement.slot_name === "mobile_2"
    //     )?.advertisement_id
    //   ) || "",
    // mobile_3:
    //   String(
    //     advertisementSlots.find(
    //       (advertisement) => advertisement.slot_name === "mobile_3"
    //     )?.advertisement_id
    //   ) || "",
    // mobile_4:
    //   String(
    //     advertisementSlots.find(
    //       (advertisement) => advertisement.slot_name === "mobile_4"
    //     )?.advertisement_id
    //   ) || "",
  }

  const { control, handleSubmit } = useForm({
    resolver: zodResolver(slotFormSchema),
    defaultValues,
  })

  const onSubmit = (data: SlotFormFormDataType) => {
    try {
      updateSlots(data).then(() => {
        showSnackbar("Advertisement slots updated", "success")
      })
    } catch (err) {
      showSnackbar("Could not assign advertisements", "error")
    }
  }

  return (
    <Stack
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      width="100%"
      gap={2}
    >
      <ControlledDropDown
        control={control}
        name="left_large"
        label="Left Large"
        options={largeImages}
        FormControlProps={{
          fullWidth: true,
        }}
      />
      <ControlledDropDown
        control={control}
        name="right_large"
        label="Right Large"
        options={largeImages}
        FormControlProps={{ fullWidth: true }}
      />
      <ControlledDropDown
        control={control}
        name="left_small"
        label="Left Small"
        options={smallImages}
        FormControlProps={{ fullWidth: true }}
      />
      <ControlledDropDown
        control={control}
        name="right_small"
        label="Right Small"
        options={smallImages}
        FormControlProps={{ fullWidth: true }}
      />
      <ControlledDropDown
        control={control}
        name="mobile_1"
        label="Mobile 1"
        options={mobileImages}
        FormControlProps={{ fullWidth: true }}
      />
      {/* <ControlledDropDown
        control={control}
        name="mobile_2"
        label="Mobile 2"
        options={mobileImages}
        FormControlProps={{ fullWidth: true }}
      />
      <ControlledDropDown
        control={control}
        name="mobile_3"
        label="Mobile 3"
        options={mobileImages}
        FormControlProps={{ fullWidth: true }}
      />
      <ControlledDropDown
        control={control}
        name="mobile_4"
        label="Mobile 4"
        options={mobileImages}
        FormControlProps={{ fullWidth: true }}
      /> */}
      <Stack direction="row" justifyContent="space-between" spacing={2} mt={5}>
        <Button variant="contained" color="primary" type="submit">
          Save
        </Button>
      </Stack>
    </Stack>
  )
}
